import { Grid, Typography } from "@material-ui/core";
import React, { useRef } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js/auto";
import { successColor } from "../../../assets/styles/base";
import { Toolbar } from "@mui/material";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default ({ data, background, title }) => {
  return (
    <div>
      <Grid
        container
        justify="center"
        style={{
          background: background || successColor[0],
          padding: 10,
          margin: "10px 0",
        }}
      >
        <Typography></Typography>

        <Toolbar>
          <Typography variant="h6" component="div">
            {title}
          </Typography>
        </Toolbar>

        <Bar
          data={data}
          options={{
            // maintainAspectRatio: true,
            animation: true,
            hover: true,
            responsive: true,
            plugins: {
              legend: {
                position: "top",
              },
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    fontColor: "#2b2929",
                  },
                },
              ],
              xAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    fontColor: "#2b2929",
                  },
                },
              ],
            },
          }}
        />
      </Grid>
    </div>
  );
};
